import { SubmissionPeriod } from "./SubmissionPeriod";
import System from "./System";

interface Submission extends Record<string, unknown> {
  id: number;
  activeSubmissionId: number;
  primacyAgencyId: number;
  pwsId: number;
  status: SubmissionStatuses | SubmissionStatus;
  statusComment: string;
  submissionPeriodId: number;
  submissionPeriod: SubmissionPeriod;
  submittedBy: string;
  submittedByName: string;
  submittedOn: string;
  createdOn: string;
  createdBy: string;
  deletedOn: string;
  deletedBy: string;
  modifiedBy: string;
  modifiedOn: string;
  overdue: boolean;
  percentKnown: number;
  additionalInfo?: { [key: string]: any };
  system: System;
  assigneeUserId?: number;
  assigneeFirstName?: string;
  assigneeLastName?: string;
}

export interface InventorySubmission extends Submission {
  // s: any;
  statusHistory: StatusHistory[];
  overdue: boolean;
  ptdPublished: boolean;
  totalServiceLinesLead: number;
  totalServiceLinesGalvanized: number;
  totalServiceLinesNonLead: number;
  totalServiceLinesUnknown: number;
  totalServiceLinesSubmitted: number;
}

export interface CNCSubmission extends Submission {
  data: CNCSubmissionData;
}

export interface CNCSubmissionData {
  submitterEmail: string;
  submitterName: string;
  submitterPhone: string;
  leadNoticeDistributions: number;
  leadNoticeDistributionsDate: string;
  grrNoticeDistributions: number;
  grrNoticeDistributionsDate: string;
  unknownNoticeDistributions: number;
  unknownNoticeDistributionsDate: string;
  mailedWithWaterBill: boolean;
  mailedWithCCR: boolean;
  separateMail: boolean;
  handDelivery: boolean;
  email: boolean;
  otherDeliveryMethod: boolean;
  lettersAttachmentsRequired: boolean;
  lastSubmittedInventoryLeadCount: number;
  lastSubmittedInventoryGrrCount: number;
  lastSubmittedInventoryUnknownCount: number;
}

interface StatusHistory {
  id: number;
  comment?: any;
  status: string;
  createdBy: string;
  createdOn: string;
}

export type SubmissionStatuses = keyof typeof SubmissionStatus;

export enum SubmissionStatus {
  "submitted" = "Submitted",
  "inReview" = "In Review",
  "rejected" = "Rejected",
  "approved" = "Accepted",
  "voided" = "Voided",
  "processingSubmission" = "Processing Submission",
  "failed" = "Failed",
  "notSubmitted" = "Not Submitted",
  "overdue" = "Overdue",
}

export default InventorySubmission;
